import styled from 'styled-components';
import { NoResult } from 'ui/illustrations';

const displayText = {
  noFilteredResults: 'No matching results',
  adjustFilters: 'Try searching for different keywords.',
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${({ theme }) => theme.spacing.values.x10} 0;
  margin-bottom: 40px;
  background-color: #fff;
  border-radius: 10px;
  ${({ theme }) => theme.elevations.smallShadow};
`;

const Title = styled.div`
  margin: 10px 0;
  font-size: ${({ theme }) => theme.styles.fontSizes.s20};
  color: ${({ theme }) => theme.colors.textColors.textPrimary};
`;

const Description = styled.div`
  font-size: ${({ theme }) => theme.styles.fontSizes.s16};
  color: ${({ theme }) => theme.colors.textColors.textSecondary};
`;

export const NoResults = () => (
  <Wrapper>
    <NoResult width={128} height={128} data-test="no-filtered-results-icon" />
    <Title>{displayText.noFilteredResults}</Title>
    <Description>{displayText.adjustFilters}</Description>
  </Wrapper>
);
